export default __webpack_public_path__ + "static/media/tile-bg-inflo-generic-01.84f987d9.png";